<template>
  <div class="tw-flex tw-items-center tw-gap-2" :class="itemClasses">
    <RadioGroupItem
      :id="id"
      class="tw-rounded-full tw-h-5 tw-w-5 tw-border-2 tw-border-solid focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-0 focus:tw-ring-primary-grey-700/20"
      :class="inputClasses"
      :value="value"
      :disabled="disabled || readonly"
      :data-test-id="testId"
      @click="emitRadio(value)"
    >
      <RadioGroupIndicator
        class="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-relative after:tw-content-[''] after:tw-block after:tw-w-2.5 after:tw-h-2.5 after:tw-rounded-full"
        :class="indicatorClasses"
      />
    </RadioGroupItem>
    <label :class="labelClasses" :for="id" :data-test-id="`${testId}-label`">
      <slot />
    </label>
  </div>
</template>
<script setup lang="ts">
import { RadioGroupIndicator, RadioGroupItem } from "reka-ui";
import { computed } from "vue";

export interface Props {
  value: string;
  testId: string;
  id: string;
  disabled?: boolean;
  readonly?: boolean;
}

const props = defineProps<Props>();

const itemClasses = computed(() => {
  if (props.disabled) {
    return "tw-text-primary-grey-200 tw-cursor-default";
  }
  if (props.readonly) {
    return "tw-cursor-not-allowed";
  }
  return "tw-cursor-pointer";
});

const inputClasses = computed(() => {
  if (props.disabled) {
    return "tw-border-primary-grey-200 data-[state='checked']:tw-border-primary-grey-200";
  }
  if (props.readonly) {
    return "tw-border-primary-grey-200 data-[state='checked']:tw-border-primary-grey-200 tw-cursor-not-allowed";
  }
  return "tw-border-primary-grey-700 data-[state='checked']:tw-border-system-success-500";
});

const indicatorClasses = computed(() => {
  if (props.disabled) {
    return "after:tw-bg-primary-grey-200";
  }
  if (props.readonly) {
    return "after:tw-bg-primary-grey-200 tw-cursor-not-allowed";
  }
  return "after:tw-bg-system-success-500";
});

const labelClasses = computed(() => {
  if (props.disabled) {
    return "tw-cursor-default";
  }
  if (props.readonly) {
    return "tw-cursor-not-allowed";
  }
  return "tw-cursor-pointer";
});

const emit = defineEmits<{ (event: "update:selected", value: string): void }>();

const emitRadio = (newValue: string) => {
  emit("update:selected", newValue);
};
</script>
